/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlannerItineraryReorderItem
 */
export interface PlannerItineraryReorderItem {
    /**
     * 
     * @type {string}
     * @memberof PlannerItineraryReorderItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerItineraryReorderItem
     */
    startDate: string | null;
}

/**
 * Check if a given object implements the PlannerItineraryReorderItem interface.
 */
export function instanceOfPlannerItineraryReorderItem(value: object): value is PlannerItineraryReorderItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    return true;
}

export function PlannerItineraryReorderItemFromJSON(json: any): PlannerItineraryReorderItem {
    return PlannerItineraryReorderItemFromJSONTyped(json, false);
}

export function PlannerItineraryReorderItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannerItineraryReorderItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'startDate': json['start_date'],
    };
}

export function PlannerItineraryReorderItemToJSON(json: any): PlannerItineraryReorderItem {
    return PlannerItineraryReorderItemToJSONTyped(json, false);
}

export function PlannerItineraryReorderItemToJSONTyped(value?: PlannerItineraryReorderItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'start_date': value['startDate'],
    };
}

